<template>
  <div class="z-[1] relative w-full border-t border-black bg-white">
    <div class="flex flex-col justify-center gap-8 px-8 text-center my-20 md:items-center md:gap-16 md:my-40">
      <ClientOnly>
        <div class="flex items-center justify-center gap-4">
          <span class="relative flex size-4">
            <span class="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-400 opacity-75"></span>
            <span class="relative inline-flex size-4 rounded-full bg-red-500"></span>
          </span>
          <h1 class="text-left md:text-center text-4xl sm:text-5xl md:text-7xl lg:text-[8rem] md:leading-[0.9] font-medium font-mono">
            {{ formattedCountdown || '—' }}
          </h1>
        </div>
        <template #fallback>
          <div class="flex items-center justify-center gap-4 min-h-[4rem]">
            <span class="relative flex size-4">
              <span class="relative inline-flex size-4 rounded-full bg-red-500"></span>
            </span>
            <h1 class="text-left md:text-center text-4xl sm:text-5xl md:text-7xl lg:text-[8rem] md:leading-[0.9] font-medium font-mono">
              —
            </h1>
          </div>
        </template>
      </ClientOnly>
      <div class="text-left md:text-center text-2xl md:text-3xl max-w-screen-sm mb-24">
        {{ displayMessage }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { useI18n } from '#imports'
import { useCountdown, getNextSeasonLaunchCET } from '~/composables/useCountdown'

const props = withDefaults(defineProps<{ message?: string }>(), {
  message: ''
})

const { t } = useI18n()

const displayMessage = computed(() => props.message || t('pages.collection.countdown.fallback'))

// Set target on client only so "now" is the user's current time (avoids SSG/build-time date)
const nextLaunch = ref<Date | null>(null)
onMounted(() => {
  nextLaunch.value = getNextSeasonLaunchCET()
})
const { formattedCountdown } = useCountdown(nextLaunch)
</script>
